import { appRouterRedirect } from '@lib/routes/helpers/nextjs/appRouterRedirect'
import PatientRoutes from '@lib/routes/PatientRoutes'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import type { ApplySuccessPageProps } from 'app/p/apply-success/[token]/[step]/page'
import EmrReleaseScroller from './EmrReleaseScroller'
import { SignatureCanvas } from './SignatureCanvas.client'

export function MedicalReleaseSignaturePrompt({
  consentForEmr,
  idToken,
}: Pick<ApplySuccessPageProps, 'consentForEmr' | 'idToken'>) {
  if (
    !consentForEmr ||
    ['Error', 'Expired', 'Revoked'].includes(consentForEmr.status)
  ) {
    return appRouterRedirect(
      PatientRoutes.postApplyStep(idToken, 'medical-release-consent'),
    )
  }
  return (
    <div className='flex h-full flex-col items-center gap-4'>
      <h4 className='w-full text-left text-xl font-bold md:text-2xl'>
        Complete Your Medical Record Release &amp; HIPAA Authorization
      </h4>

      <EmrReleaseScroller consent={consentForEmr} />

      <SignatureCanvas
        onSignatureChange={() =>
          trackEvent(TrackingEvents.EMR_RELEASE_INPUT_MODIFIED, {
            type: 'signature-canvas',
          })
        }
      />
    </div>
  )
}
